































import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'GStatisticsBoxplotSubTableInfoTable',
  components: {},
  computed: {},
  methods: {},
})
export default class GStatisticsBoxplotSubTableInfoTable extends Vue {
  mounted() {}
}
